import { Link } from "react-router-dom";
import { LogoStyle } from "./style";

function Logo({ isLogged }) {
  return (
    <>
      <LogoStyle>
        <div className="logo-container-desktop">
          <Link to={isLogged === true ? `/home` : `/`}>
            <img className="logo-img" src="/logo-flex-frete-s-Slogan-horizontal.png" alt="logo" />
          </Link>
        </div>
        <div className="logo-container-mobile">
          <Link to={isLogged === true ? `/home` : `/`}>
            <img className="logo-img" src="/logo-flex-frete-s-Slogan-CMYK.jpg" alt="logo" />
          </Link>
        </div>
      </LogoStyle>
    </>
  );
}

export default Logo;
